import * as actionTypes from './actionTypes';

import roleService from '../../services/roleService';
import { showAlert } from './uiActions';

// Fetch Roles
export const fetchRoles = (params = {}) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_ROLES_REQUEST });
  try {
    const response = await roleService.getRoles(params);
    dispatch({
      type: actionTypes.FETCH_ROLES_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_ROLES_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch roles',
    });
  }
};

// Fetch Single Role
export const fetchRole = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.FETCH_ROLE_REQUEST });
  try {
    const response = await roleService.getRole(id);
    dispatch({
      type: actionTypes.FETCH_ROLE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.FETCH_ROLE_FAILURE,
      payload: error.response?.data?.error || 'Failed to fetch role',
    });
  }
};

// Create Role
export const createRole = (roleData) => async (dispatch) => {
  dispatch({ type: actionTypes.CREATE_ROLE_REQUEST });
  try {
    const response = await roleService.createRole(roleData);
    dispatch({
      type: actionTypes.CREATE_ROLE_SUCCESS,
      payload: response.data,
    });
    dispatch(showAlert('Role created successfully', 'success'));
    return response.data;
  } catch (error) {
    dispatch({
      type: actionTypes.CREATE_ROLE_FAILURE,
      payload: error.response?.data?.error || 'Failed to create role',
    });
    dispatch(showAlert(error.response?.data?.error || 'Failed to create role', 'error'));
    throw error;
  }
};

// Update Role
export const updateRole = (id, roleData) => async (dispatch) => {
  dispatch({ type: actionTypes.UPDATE_ROLE_REQUEST });
  try {
    const response = await roleService.updateRole(id, roleData);
    dispatch({
      type: actionTypes.UPDATE_ROLE_SUCCESS,
      payload: response.data,
    });
    dispatch(showAlert('Role updated successfully', 'success'));
    return response.data;
  } catch (error) {
    dispatch({
      type: actionTypes.UPDATE_ROLE_FAILURE,
      payload: error.response?.data?.error || 'Failed to update role',
    });
    dispatch(showAlert(error.response?.data?.error || 'Failed to update role', 'error'));
    throw error;
  }
};

// Delete Role
export const deleteRole = (id) => async (dispatch) => {
  dispatch({ type: actionTypes.DELETE_ROLE_REQUEST });
  try {
    await roleService.deleteRole(id);
    dispatch({
      type: actionTypes.DELETE_ROLE_SUCCESS,
      payload: id,
    });
    dispatch(showAlert('Role deleted successfully', 'success'));
  } catch (error) {
    dispatch({
      type: actionTypes.DELETE_ROLE_FAILURE,
      payload: error.response?.data?.error || 'Failed to delete role',
    });
    dispatch(showAlert(error.response?.data?.error || 'Failed to delete role', 'error'));
    throw error;
  }
};

// Assign Permissions to Role
export const assignPermissionsToRole = (id, permissionIds) => async (dispatch) => {
  dispatch({ type: actionTypes.ASSIGN_PERMISSIONS_TO_ROLE_REQUEST });
  try {
    const response = await roleService.assignPermissions(id, permissionIds);
    dispatch({
      type: actionTypes.ASSIGN_PERMISSIONS_TO_ROLE_SUCCESS,
      payload: response.data,
    });
    dispatch(showAlert('Permissions assigned successfully', 'success'));
  } catch (error) {
    dispatch({
      type: actionTypes.ASSIGN_PERMISSIONS_TO_ROLE_FAILURE,
      payload: error.response?.data?.error || 'Failed to assign permissions',
    });
    dispatch(showAlert(error.response?.data?.error || 'Failed to assign permissions', 'error'));
  }
};

export const clearRoleSuccess = () => ({ type: actionTypes.CLEAR_ROLE_SUCCESS });
export const clearRoleError = () => ({ type: actionTypes.CLEAR_ROLE_ERROR });